// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/source/api/source_sync.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { SourceSyncService } from "./source_sync_pb.js";

/**
 * Sync CRUD
 *
 * @generated from rpc gx.source.api.SourceSyncService.CreateSourceSync
 */
export const createSourceSync = SourceSyncService.method.createSourceSync;

/**
 * @generated from rpc gx.source.api.SourceSyncService.GetSourceSync
 */
export const getSourceSync = SourceSyncService.method.getSourceSync;

/**
 * @generated from rpc gx.source.api.SourceSyncService.ListSourceSyncs
 */
export const listSourceSyncs = SourceSyncService.method.listSourceSyncs;

/**
 * @generated from rpc gx.source.api.SourceSyncService.UpdateSourceSync
 */
export const updateSourceSync = SourceSyncService.method.updateSourceSync;

/**
 * @generated from rpc gx.source.api.SourceSyncService.DeleteSourceSync
 */
export const deleteSourceSync = SourceSyncService.method.deleteSourceSync;

/**
 * @generated from rpc gx.source.api.SourceSyncService.GetLatestSourceSync
 */
export const getLatestSourceSync = SourceSyncService.method.getLatestSourceSync;

/**
 * @generated from rpc gx.source.api.SourceSyncService.CancelSourceSync
 */
export const cancelSourceSync = SourceSyncService.method.cancelSourceSync;
